import Splide from '@splidejs/splide';

const EL = '.js-hero-carousel';
const ACTIVE_CLASS = 'is-active';

if (document.querySelector(EL)) {
  const slider = new Splide(EL, {
    type: 'fade',
    pagination: true,
    arrows: false,
    autoplay: true,
    interval: 3000,
    pauseOnHover: false,
    pauseOnFocus: false,
    rewind: true
  }).mount();
}
